import { Pipe, PipeTransform } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { setRecipientData } from 'app/global/get-recipient-data';
import {  Personfield, Recipient } from 'app/main/pages/edit-template/edit-template.dto';

@Pipe({
  name: 'getRecipient'
})
export class GetRecipientPipe implements PipeTransform {


  constructor (private _translocoService$: TranslocoService) {}


  transform(personfields: Personfield[], type:string = "string"): string | Recipient {
    const recipient: Recipient = setRecipientData(personfields, true);
    let typeofData: string | Recipient;

    if(type == 'string'){
      typeofData = recipient?.firstname ? recipient?.firstname+ ' '+ (recipient?.lastname || '') : this._translocoService$.translate('Add recipient text (Template/Document RecipientTab - section) - Add recipient');
    }else{
      typeofData = recipient ;
    }
    return typeofData;
  }

}
